import React, { FC, useContext, useEffect, useState } from 'react'
import { StyleSheet, Text, View, Pressable } from 'react-native'
import { IArticle } from '../api/articles'
import { fetchTranslation } from '../api/articles/articles.query'
import { ILanguage } from '../api/languages'
import Colors from '../constants/Colors'
import { UserContext } from '../context'
import { LanguagesContext } from '../context/languages.context'
import { LanguageSelectorComponent } from './LanguageSelectorComponent'
import Icon from 'react-native-vector-icons/MaterialIcons'
import { SentimentIcon } from './SentimentIcon'
import { multiLanguageDisabled } from '../constants/Config'

export interface ITileFunctionBarProps {
  article: IArticle
  onArticleTitleChange: (language: string) => void
  isUnread: boolean
}

export const TileFunctionBar: FC<ITileFunctionBarProps> = ({
  article,
  onArticleTitleChange: onArticleTitleChangeProp,
  isUnread,
}) => {
  const { user, setBookmarks } = useContext(UserContext)
  const { languages } = useContext(LanguagesContext)
  const index = user.BookmarkedNews.indexOf(article.ArticleKey)
  const isBookmarked = index > -1

  return (
    <View
      style={[
        styles.titleFavoriteContainer,
        {
          justifyContent: !!article.SentimentTag ? 'space-between' : 'flex-end',
        },
      ]}
    >
      {!!article.SentimentTag ? (
        <View style={styles.sentimentWrapper}>
          <SentimentIcon
            sentimentTag={article.SentimentTag}
            isInternalArticle={false}
          />
        </View>
      ) : null}
      {isUnread ? <View style={styles.circle} /> : null}
    </View>
  )
}

const styles = StyleSheet.create({
  titleFavoriteContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    padding: 5,
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  sentimentWrapper: {
    backgroundColor: Colors.oxfordBlue + 90,
    borderRadius: 5,
    padding: 5,
    height: 'fit-content',
  },
  bookMarksWrappwer: {
    backgroundColor: Colors.oxfordBlue + 90,
    borderRadius: 5,
    padding: 5,
  },
  favoriteIcon: {
    color: Colors.darkPlatinum,
  },
  topRightContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 5,
  },
  circle: {
    width: 10,
    height: 10,
    borderRadius: 50,
    backgroundColor: Colors.orangeWeb,
    marginLeft: 5,
    border: 4,
    borderColor: 'rgba(0, 0, 0, 0.3)',
  },
})
